class Contact {
    constructor() {
        this.$form = $('.js-contact-form');
        this.$contactText = $('.js-contact-text');
        this.$contactTitle = $('.js-contact-title');

        $('.js-contact-close').on('click', (e) => {
            this.$form.removeClass('open');
        });
    }

    addButton(selector) {
        $(selector).on('click', (e) => {
            e.preventDefault();

            this.$form.removeClass('open');

            this.setTitle(e);
            this.setEmail(e);
            this.setText(e);
            this.setUpload(e);
            this.setSelect(e);

            const input = document.querySelector('select');

            input.addEventListener('input', () => {
                if (TOCONTACT[input.value]) {
                    setEmail(TOCONTACT[input.value]);
                } else {
                    setEmail("info@kavka.be");
                }
            });

            this.$form.addClass('open');
        })
    }

    setText(e) {
        if ($(e.currentTarget).data("text")) {
            this.$contactText.html($(e.currentTarget).data("text"));
        } else {
            this.$contactText.html("Heb je een vraag? Laat hier een bericht achter of bel ons op 03 290 88 17.");
        }
    }

    setSelect(e) {
        this.$contactSelect = $('.js-select_to_contact');

        if ($(e.currentTarget).data("select") || $(e.currentTarget).hasClass('js-add-select')) {
            this.$contactSelect.show();
        } else {
            this.$contactSelect.hide();
        }
    }

    setUpload(e) {
        this.$contactUpload = $('.js-file-upload');

        if ($(e.currentTarget).data("upload")) {
            this.$contactUpload.show();
        } else {
            this.$contactUpload.hide();
        }
    }

    setTitle(e) {
        if ($(e.currentTarget).data("title")) {
            this.$contactTitle.html($(e.currentTarget).data("title"));
            setTopic($(e.currentTarget).data("title"));
        } else {
            this.$contactTitle.html("Contacteer ons");
            setTopic("Contacteer ons");
        }
    }

    setEmail(e) {
        if ($(e.currentTarget).data("email")) {
            console.log($(e.currentTarget).data("email"));
            setEmail($(e.currentTarget).data("email"));
        } else if ($(e.currentTarget).data("team")) {
            setEmail($(e.currentTarget).data("team"));
        } else {
            setEmail("info@kavka.be");
        }
    }
}

module.exports = Contact;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/contact.js